<template>
  <oie-the-navigation-accordion-shell :open-on-init="false" custom-toggle-event="close-market-selector">
    <template slot="toggler">
      <oie-use-svg svg="global" class="navigation-item__icon"></oie-use-svg>
      {{ currentMarket.text + ' / ' + currentLanguage }}
    </template>

    <template slot="content">
      <oie-the-market-selector
        :markets="availableMarkets"
        :referrer-url="referrerUrl"
        css-classes="navigation-market-selector__content"></oie-the-market-selector>
    </template>
  </oie-the-navigation-accordion-shell>
</template>

<script>
export default {
  props: {
    availableMarkets: {
      type: Array,
      required: true
    },
    referrerUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    currentMarket() {
      return this.availableMarkets.find(m => m.selected)
    },
    currentLanguage() {
      return this.clientModel.currentLanguage
    }
  }
}
</script>
